import React from "react";
import { Line } from "react-chartjs-2";

const DiscountByTimeReport = ({
  chartData,
  chartOptions,
  storess,
  selectedDate,
  chartRef,
  containerId,
}) => (
  <div ref={chartRef} id={containerId}>
    <div className="card">
      <Line data={chartData} options={chartOptions} />
    </div>

    <div className="print-only-content">
      <h2>Report Details</h2>
      <div className="print-only-content">
        <div>
          <h3>Brand: Angels Pizza</h3>
          <h3>Store: {storess}</h3>
          <h3>Date: {selectedDate}</h3>
        </div>
      </div>

      <div style={{ fontSize: "20px" }}>
        <table className="table text-center">
          <thead>
            <tr className="d-flex">
              <th>Time</th>
              <th className="ms-5">Discount Value</th>
            </tr>
          </thead>
          <tbody>
            {chartData.labels.map((label, index) => (
              <tr className="d-flex" key={`${containerId}-${index}`}>
                <td className="ms-5">{label} ------------ </td>
                <td className="ms-5">{chartData.datasets[0].data[index]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default DiscountByTimeReport;
